<template>
  <div v-if="!isLoading" class="h-100">
    <ExpiredResetPassword v-if="expired"></ExpiredResetPassword>
    <ChooseNewPassword v-else></ChooseNewPassword>
  </div>
</template>

<script>
import ChooseNewPassword from './components/ChooseNewPassword';
import ExpiredResetPassword from './components/ExpiredResetPassword';
import jwt from 'jsonwebtoken';
import User from '@/models/User';
import Utility from '@/models/Utility';
import { amplitudeMixin } from '@/mixins/amplitudeMixin';

export default {
  components: {
    ChooseNewPassword,
    ExpiredResetPassword
  },
  mixins: [amplitudeMixin],

  data() {
    return {
      expired: false,
      isLoading: false
    };
  },

  computed: {
    user() {
      return User.query().first();
    }
  },

  watch: {
    '$route.query.token': {
      immediate: true,
      handler: 'checkExpriedLink'
    }
  },

  methods: {
    async checkExpriedLink(token) {
      if (!token) {
        this.$_amplitudeMixin_onCheck({
          IsExpired: true,
          Message: 'Invalid Token'
        });

        return (this.expired = true);
      }

      try {
        if (this.user) this.$router.push({ name: 'home' });

        this.isLoading = true;
        const decoded = jwt.decode(token, { complete: true });
        if (decoded.payload) {
          const { response } = await Utility.api().checkExpried(
            {
              token: token,
              userId: decoded.payload.user
            },
            { save: false }
          );
          this.expired = response.data;

          this.$_amplitudeMixin_onCheck({
            Token: token,
            IsExpired: this.expired
          });
          // if (Date.now() >= decoded.payload.exp * 1000) {
          //   this.expired = true;
          // }
        }
      } catch (error) {
        this.expired = true;
        const { message = '' } = error;
        this.$_amplitudeMixin_onCheck({
          Token: token,
          IsExpired: this.expired,
          Message: message
        });
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
